import React from 'react'
import { connect } from 'react-redux'

const styles = {
  main: {
    padding: 5,
    'font-size': '16px',
  },
}

class Wrongs extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      wrongs: 0,
    }
  }

  color = () =>
    (this.state.wrongs > 0 ? '#d50000' : '#00c853')

  text = () =>
    `  ${this.props.wrongs}`

  render() {
    return (
      <div
        style={styles.main}
        className="mui--text-headline mui--text-center"
      >
        Fallos:
        <span style={{ color: this.color() }}>
          {this.text()}
        </span>
      </div>
    )
  }
}

Wrongs.propTypes = {
  wrongs: React.PropTypes.number,
}

const mapStateToProps = state => ({
  wrongs: state.missions.answerMission.progress.wrongs,
})

const mapDispatchToProps = () => ({})


export default connect(mapStateToProps, mapDispatchToProps)(Wrongs)



// WEBPACK FOOTER //
// ./src/components/MissionFinish/SummaryMission/Wrongs/index.jsx